//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import $ from 'jquery';
import axios from 'axios';
export default {
    data: function data() {
        return {
            Countries: '',
            englishLetters: ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'],
            arabicLetters: ['ا', 'ب', 'ت', 'ث', 'ج', 'ح', 'خ', 'د', 'ذ', 'ر', 'ز', 'س', 'ش', 'ص', 'ض', 'ط', 'ظ', 'ع', 'غ', 'ف', 'ق', 'ك', 'ل', 'م', 'ن', 'ه', 'و', 'ي']
        };
    },
    mounted: function mounted() {},

    computed: {
        lang: function lang() {
            return this.$root._route.params.lang;
        }
    },
    created: function created() {
        var _this = this;

        var subscriptionUrl = global.getEndPoint() + 'api/search-country-city-letter?h=hjkkfsdDSFDSAF@$&lang=' + this.lang;
        axios.get(subscriptionUrl).then(function (res) {
            _this.Countries = res.data;
        }).catch(function (err) {
            _this.loading = false;
            if (err.message) {
                if (flash) flash(_this.$root.trans('st_public.' + err.message), 'error');
            }
            _this.errors.clear();
            var errors = err.response.data.errors;
            if (errors) {
                for (var field in errors) {
                    _this.errors.add(field, errors[field].join(', '));
                }
            }
        });
    },

    methods: {
        contactus: function contactus() {},
        getAllCookies: function getAllCookies() {
            if (process.client) {
                return document.cookie;
            }
            return '';
        },
        countryCityLink: function countryCityLink(country, state, city) {
            var country_name = this.replaceSpaces(country.country_name.toString());
            var state_name = '';
            if (state.state != '') state_name = this.replaceSpaces(state.state.toString());else state_name = this.$root.trans('st_public.Other', this.lang);
            var city_name = this.replaceSpaces(city.city.toString());
            if (!city_name) city_name = this.$root.trans('st_public.Other', this.lang);
            return '/' + this.lang + '/directory/' + country_name + '/' + state_name + '/' + city_name + '/' + city.id + '/1';
        },
        replaceSpaces: function replaceSpaces(target) {
            return target.replace(new RegExp(' ', 'g'), '-');
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/var/www/html/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./pages/_lang/directory/index.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/var/www/html/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./pages/_lang/directory/index.vue
// module chunks = 28